import { render } from "./TheVideoGallery.vue?vue&type=template&id=2b1eff6d&scoped=true"
import script from "./TheVideoGallery.vue?vue&type=script&lang=js"
export * from "./TheVideoGallery.vue?vue&type=script&lang=js"

import "./TheVideoGallery.vue?vue&type=style&index=0&id=2b1eff6d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1eff6d"]])

export default __exports__